import Database from '@/services/offline/database.js'

class JobsCache extends Database {

  constructor() {
    super()
  }

  _storeName() {
    return 'jobs'
  }

  /**
   * @param {Object} param - Cache parameters
   * @param {Object[]} param.jobs - Jobs to cache
   */
  async cache({ jobs }) {
    let storageKey = this._createStorageKey()

    const db = await this.dbPromise
    await db.put(this._storeName(), jobs, storageKey)
  }

  async get() {
    let storageKey = this._createStorageKey()

    const db = await this.dbPromise
    return await db.get(this._storeName(), storageKey)
  }

  async cachePresent() {
    return !!(await this.get())
  }

  async deleteAllCache() {
    const db = await this.dbPromise
    return await db.clear(this._storeName())
  }

  _createStorageKey() {
    return 'jobs'
  }
}

export default new JobsCache()